<template>
    <!-- 开机率报表 -->
    <div class="rzy-page">
        <el-date-picker v-model="selectMonth" type="month" placeholder="选择月" @change="changeMonth" />
        <el-button type="success" @click="initExcel('runningRateTable')">导出Excel</el-button>
        <el-table :data="runningRateList" :header-cell-style="{'text-align':'center'}" id="runningRateTable"
            :cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600">
            <el-table-column v-for="(obj,key,index) in sumLeftKeys" :key="index" fixed="left" :label="obj.value"
                :prop="key" :width="obj.width" />
            <el-table-column :label="`${index+1}号`" v-for="(item,index) in lastDate" :key="item" width="80">
                <template slot-scope="data">
                    {{data.row.dailyData[index].runningRate}}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: 'machineRunning',
        data() {
            return {
                sumLeftKeys: {
                    title: {
                        value: '机台',
                        width: '120'
                    },
                    meanRunningRate: {
                        value: '平均开机率',
                        width: '80'
                    }
                },
                runningRateList: [],
                selectMonth: '',
                lastDate: 0 //hongmj: 列表上最后1天。
            }
        },
        methods: {
            // 获取当前月的数据
            getNowCount() {
                const now = new Date().getTime()
                this.selectMonth = now
                this.getMachineCount(this.utils.getFirstTimeByMonth(now), this.utils.getLastTimeByMonth(now))
            },
            // 获取开始到结束的数据
            getMachineCount(startTime, endTime) {
                return this.$requestBase({
                    url: 'v1/factory/machine/count/daily',
                    method: 'get',
                    params: {
                        startTime,
                        endTime
                    }
                }).then((res) => {
                    if (this.utils.isNowMonth(startTime)) { //hongmj: 当天，列表最后1天 直接取今天。
                        this.lastDate = new Date().getDate()
                    } else { //hongmj:取当月最后1天。
                        this.lastDate = new Date(endTime).getDate()
                    }
                    this.formatMachineCount(res.data)
                })
            },
            // 格式化数据
            formatMachineCount(response) {
                //hongmj: 按机台号 分组?
                var groupByMachineId = this._.groupBy(response.dailyDataList, (item) => {
                    return item.machineId
                })
                
                // hongmj: 调试打开
                // for (const machineId in groupByMachineId) {  
                //     console.log(`Machine ID: ${machineId}`);  
                //     console.log("groupByMachineId[machineId]=", groupByMachineId[machineId]);  
                // }
                
                // 补全机台
                var formatArr = this.completionMachine(response.machineList, groupByMachineId)
                
                const date = this.lastDate //hongmj: 列表最后1天
// this._.range(0, date, 0) 实际上会尝试生成一个从 0 开始到 date（不包括 date）的数组，
// 但由于步长被设置为 0，这会导致函数无法正确生成序列，因为步长为 0 意味着序列中的每个数字都将是相同的，
// 这不符合 _.range 的预期用法。
                var sumRate = this._.range(0, date, 0) //hongmj: 总开机率
                var sumLive = this._.range(0, date, 0) //hongmj: 有效的“开机率”总数?
                console.log("sumRate=",sumRate)
                console.log("sumLive=",sumLive)
                
                for (var machineId in groupByMachineId) {
                    var machineData = groupByMachineId[machineId] //hongmj: 取1个机台所有数据
                    var dailyData = this._.range(date)
                    var meanRate = 0
                    var meanLive = 0
                    machineData.forEach((item) => {
                        const index = new Date(item.whichDay).getDate() - 1

						// 24小时 * 3600秒 = 86400秒.
                        const rate = parseFloat(item.runningTime / 86400) //hongmj: 当天开机率?
                        sumRate[index] += rate
                        sumLive[index] += 1
                        meanRate += rate
                        meanLive += 1
                        dailyData[index] = {
                            runningTime: item.runningTime,
                            date: index + 1,
                            runningRate: (rate * 100).toFixed(2) + '%'
                        }
                    })
                    
                    // 补齐没有开机率的天数
                    dailyData = this.completionDailyData(dailyData)
                    var formatObj = {
                        title: `${machineData[0].machineNum}(${machineData[0].machineWorkShop})`,
                        machineId: machineData[0].machineId,
                        machineNum: machineData[0].machineNum,
                        machineWorkShop: machineData[0].machineWorkShop,
                        meanRunningRate: ((meanRate / meanLive) * 100).toFixed(2) + '%',
                        dailyData: dailyData
                    }
                    formatArr.push(formatObj)
                }
                formatArr = this._.sortBy(formatArr, (obj) => {
                    // 默认升序 降序return的结果加 - ，-obj.machine.number
                    // 提取字母 obj.machineNumber.replace(/[^a-z]+/ig,"");
                    var machineNumber = obj.machineNum.replace(/[^0-9]+/gi, '')
                    return Number(machineNumber)
                })
                const sumCount = this.formatSumCount({
                    sumRate,
                    sumLive
                })
                this.runningRateList = sumCount.concat(formatArr)
            },
            // 补全机台
            completionMachine(machineList, groupByMachineId) {
                const formatArr = []
                machineList.forEach((item) => {
                    if (!this._.has(groupByMachineId, item.machineId)) {
                        let dailyData = this._.range(this.lastDate)
                        dailyData = this.completionDailyData(dailyData)
                        formatArr.push({
                            title: `${item.machineNum}(${item.machineWorkShop})`,
                            machineId: item.machineId,
                            machineNum: item.machineNum,
                            machineWorkShop: item.machineWorkShop,
                            meanRunningRate: 0,
                            dailyData
                        })
                    }
                })
                return formatArr
            },
            // 补全没有数据的天
            completionDailyData(dailyData) {
                dailyData.forEach((item, index) => {
                    if (!this._.isObject(item)) {
                        dailyData[index] = {
                            runningTime: 0,
                            date: index + 1,
                            runningRate: this.$params.countEmpty
                        }
                    }
                })
                return dailyData
            },
            // 抽出汇总逻辑
            formatSumCount(sumObj) {
                var sumDailyData = this._.range(this.lastDate)
                var meanRate = 0
                var meanLive = 0
                sumDailyData.forEach((item, index) => {
                    if (sumObj.sumLive[index] > 0) {
                        var rate = sumObj.sumRate[index] / sumObj.sumLive[index]
                        meanRate += rate
                        meanLive += 1
                        sumDailyData[index] = {
                            date: index + 1,
                            runningRate: (rate * 100).toFixed(2) + '%'
                        }
                    } else {
                        sumDailyData[index] = {
                            date: index + 1,
                            runningRate: this.$params.countEmpty
                        }
                    }
                })
                var formatSum = [{
                    title: '汇总',
                    meanRunningRate: meanLive > 0 ? ((meanRate / meanLive) * 100).toFixed(2) + '%' : 0,
                    dailyData: sumDailyData
                }]
                return formatSum
            },
            // 切换月份
            changeMonth(val) {
                const selectTime = val.getTime()
                this.getMachineCount(this.utils.getFirstTimeByMonth(selectTime), this.utils.getLastTimeByMonth(
                    selectTime))
            },
            // 导出excel初始化
            initExcel(id) {
                const select = new Date(this.selectMonth)
                const year = select.getFullYear()
                const month = select.getMonth() + 1
                this.utils.exportExcel(id, `${year}年${month}月机台开机率报表`)
            }
        },
        created() {
            this.getNowCount()
        }
    }
</script>

<style lang='scss' scoped>
</style>